import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiArrowUpRight } from 'react-icons/fi';

function FooterModern() {
  const currentYear = new Date().getFullYear();

  const practiceAreas = [
    'IPC & Criminal Law', 'Civil & Contract Law', 'Family Law',
    'Corporate & Tax Law', 'Property Disputes', 'Immigration Law'
  ];

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'Find Lawyer', path: '/lawyers' },
    { label: 'Case Studies', path: '/case-studies' },
    { label: 'About Us', path: '/about' },
    { label: 'Our Team', path: '/team' },
    { label: 'Contact', path: '/contact' },
    { label: 'Book Consultation', path: '/booking' },
  ];

  return (
    <footer className="bg-secondary-900 text-white relative overflow-hidden">
      {/* Decorative top border */}
      <div className="h-1 bg-gradient-to-r from-primary-500 via-accent-500 to-teal-500" />

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-accent-400 to-accent-600 flex items-center justify-center">
                <span className="text-lg">⚖️</span>
              </div>
              <span className="text-xl font-bold text-white tracking-tight">Bihar Lawyer</span>
            </Link>
            <p className="text-secondary-400 text-sm leading-relaxed mb-6">
              Professional legal services providing expert guidance and representation under Indian law across all areas of practice.
            </p>
            <div className="flex gap-3">
              {['in', '𝕏', 'f'].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-lg bg-secondary-800 hover:bg-primary-500 flex items-center justify-center text-secondary-400 hover:text-white transition-all duration-200 text-sm font-semibold"
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Practice Areas */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Practice Areas</h4>
            <ul className="space-y-3">
              {practiceAreas.map((area, i) => (
                <li key={i}>
                  <Link
                    to="/lawyers"
                    className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 flex items-center gap-1 group"
                  >
                    {area}
                    <FiArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.path}
                    className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 flex items-center gap-1 group"
                  >
                    {link.label}
                    <FiArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Get In Touch</h4>
            <div className="space-y-4">
              <a href="tel:+919999999999" className="flex items-start gap-3 text-sm text-secondary-400 hover:text-white transition-colors group">
                <FiPhone className="w-4 h-4 mt-0.5 text-accent-500" />
                <span>+91 (999) 999-9999</span>
              </a>
              <a href="mailto:info@biharlawyer.in" className="flex items-start gap-3 text-sm text-secondary-400 hover:text-white transition-colors group">
                <FiMail className="w-4 h-4 mt-0.5 text-accent-500" />
                <span>info@biharlawyer.in</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-secondary-400">
                <FiMapPin className="w-4 h-4 mt-0.5 text-accent-500 flex-shrink-0" />
                <span>Patna, Bihar, India<br/>All Indian State Bar Councils</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-secondary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-secondary-500">
              &copy; {currentYear} Bihar Lawyer Legal Services. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              {['Privacy Policy', 'Terms of Service', 'Legal Disclaimer'].map((link, i) => (
                <Link key={i} to="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">
                  {link}
                </Link>
              ))}
            </div>
          </div>
          <p className="text-xs text-secondary-600 mt-4 text-center md:text-left">
            This portal provides information about legal services under Indian law. Nothing on this website constitutes legal advice. Subject to jurisdiction of Indian courts.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default FooterModern;
